import { createContext } from 'react';
import { IDadosUsuario } from '../types/DadosUsuario';
import { IAtalhos } from '../types/Atalhos';

// Empresa (tenant) validada na API pelo ValidaEmpresa (GET /tenant)
export interface IEmpresa {
  raz: string;
  fil: string;
  cnpj: string;
  /** config GradeProdutoWeb = '1': mostra a grade (cor x tamanho) na ficha do produto */
  grade?: boolean;
}

export interface IContext {
  empresa: IEmpresa | undefined;
  setEmpresa: (empresa: IEmpresa | undefined) => void;
  isLoadingOverlay: boolean;
  setIsLoadingOverlay: (isLoadingOverlay: boolean) => void;
  dadosUsuario: IDadosUsuario;
  setDadosUsuario: (dadosUsuario: IDadosUsuario) => void;
  atalhos: IAtalhos | undefined;
  setAtalhos: (atalhos: IAtalhos | undefined) => void;
}

const Context = createContext<IContext>({} as IContext);

export default Context;
